import { render, staticRenderFns } from "./Header.vue?vue&type=template&id=a66060c2&scoped=true"
import script from "./Header.vue?vue&type=script&lang=js"
export * from "./Header.vue?vue&type=script&lang=js"
import style0 from "./Header.vue?vue&type=style&index=0&id=a66060c2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a66060c2",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {Medias: require('/vercel/path0/components/elements/Medias/index.vue').default})
